import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    title: {
        id: '_.xsell.flexiScheduleModal.title',
        defaultMessage: 'Repayment Schedule'
    },
    dateHeader: {
        id: '_.xsell.flexiScheduleModal.date_header',
        defaultMessage: 'Date'
    },
    interestHeader: {
        id: '_.xsell.flexiScheduleModal.interest_header',
        defaultMessage: 'Interest'
    },
    principleHeader: {
        id: '_.xsell.flexiScheduleModal.principle_header',
        defaultMessage: 'Principle'
    },
    totalHeader: {
        id: '_.xsell.flexiScheduleModal.total_header',
        defaultMessage: 'Total'
    }
});
